import { render, staticRenderFns } from "./SendNotificationModal.vue?vue&type=template&id=3a6c72a2&"
import script from "./SendNotificationModal.vue?vue&type=script&lang=js&"
export * from "./SendNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports